export default __webpack_public_path__ + "static/media/avalanche.feab6c88.svg";